<template>
  <DSPopover>
    <DSPopoverTrigger as-child>
      <DSButtonIndicator
        :indicator="indicator"
        variant="secondary"
        size="icon-sm"
        aria-label="Columns"
      >
        <ArrowUpDown class="size-3.5" />
      </DSButtonIndicator>
    </DSPopoverTrigger>
    <DSPopoverContent
      @focus-outside="keepOpenWhileSorting"
      @interact-outside="keepOpenWhileSorting"
      @pointer-down-outside="keepOpenWhileSorting"
    >
      <div class="text-sm font-semibold leading-tight mb-1.5">
        {{ label }}
      </div>
      <div class="flex gap-2">
        <DSPivotSortControl
          v-model:cleared-sort="clearedSortCols"
          v-model:sort-storage="sortColumnsStorage"
          label="Columns"
          :sort-fields="sortFieldsCols"
          :readonly
        />
        <DSPivotSortControl
          v-model:cleared-sort="clearedSortRows"
          v-model:sort-storage="sortRowsStorage"
          label="Rows"
          :sort-fields="sortFieldsRows"
          :readonly
        />
      </div>
    </DSPopoverContent>
  </DSPopover>
</template>

<script setup lang="ts">
import { Sort } from '@types'

import { DSButtonIndicator, DSPivotSortControl, DSPopover, DSPopoverContent, DSPopoverTrigger } from '@ds'
import type { PivotTableSortOption } from '@/components/DS/patterns/Pivot/utils/types'
import { ArrowUpDown } from '@lucide/vue'
import { computed } from 'vue'

interface PivotSortControlProps {
  label: string
  sortFieldsCols: PivotTableSortOption[]
  sortFieldsRows: PivotTableSortOption[]
  readonly?: boolean
}

defineProps<PivotSortControlProps>()

defineOptions({
  inheritAttrs: false,
})

const clearedSortCols = defineModel<Sort[]>('cleared-sort-cols')
const sortColumnsStorage = defineModel<Sort[]>('sort-storage-cols')
const clearedSortRows = defineModel<Sort[]>('cleared-sort-rows')
const sortRowsStorage = defineModel<Sort[]>('sort-storage-rows')

const indicator = computed(() => {
  return !!clearedSortCols.value?.length || !!clearedSortRows.value?.length
})

/*
 * Sort menus are portaled dropdowns outside the popover DOM.
 * This prevents Reka from closing the popover when interacting with them, but
 * clicks elsewhere still close it.
 */
const keepOpenWhileSorting = (event: Event) => {
  const target = event.target
  if (!(target instanceof Element)) return
  if (target.closest('.v-popper__popper')) event.preventDefault()
}
</script>
